import { EVENT_DATE_LABEL } from "../../config/event";
import { Diamond } from "./primitives";

export const TopBanner = () => (
  <div className="banner-sweep relative overflow-hidden bg-[linear-gradient(180deg,#141210,#050505)]" data-testid="top-banner">
    <div className="hairline" aria-hidden="true" />
    <div className="gutter flex flex-col items-center justify-center gap-1 py-2.5 text-center md:flex-row md:gap-4 md:whitespace-nowrap">
      <span className="fade-rule-l hidden w-24 md:block lg:w-40" aria-hidden="true" />
      <span className="font-serif-it text-[15px] text-[#efe6d1]" data-testid="top-banner-invitation">An invitation</span>
      <Diamond className="hidden text-[9px] md:inline" />
      <span className="font-mono-plex text-[10.5px] tracking-[0.14em] text-[var(--gold)] sm:text-[11px] sm:tracking-[0.2em]" data-testid="top-banner-date">
        FREE LIVE MASTERCLASS · <span className="whitespace-nowrap">{EVENT_DATE_LABEL}</span>
      </span>
      <Diamond className="hidden text-[9px] md:inline" />
      <span className="font-mono-plex hidden text-[11px] tracking-[0.2em] text-[#cfc6b3] md:inline" data-testid="top-banner-zoom">LIVE ON ZOOM · Q&amp;A</span>
      <span className="fade-rule-r hidden w-24 md:block lg:w-40" aria-hidden="true" />
    </div>
    <div className="hairline" aria-hidden="true" />
  </div>
);
